import React from 'react';
import BaseCell from './BaseCell';
import { Checkbox } from '@progress/kendo-react-inputs';

const CheckboxCell = ({ checked, onChange, ...props }) => (
  <BaseCell
    {...props}
    selectable={false}
  >
    <Checkbox value={checked} onChange={onChange} {...props} />
  </BaseCell>
);

export default CheckboxCell;
